export var listIds = new WeakMap();

function normalizeKey(key) {
  if (typeof key === 'string') {
    return key.replace(/\s*/g, '');
  }

  return '' + key;
}

export function getItemId(state, itemKey) {
  var listId = listIds.get(state);

  if (!listId) {
    throw new Error('Unknown list');
  }

  return "".concat(listId, "-option-").concat(normalizeKey(itemKey));
}